import { Component, ElementRef, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject, take, takeUntil } from 'rxjs';
import { TechSupportModel } from 'src/app/admin-panel/models/system-profiles/tech-support.model';
import { AdministratorService } from 'src/app/admin-panel/services/system-profiles/administrator-service';
import { CompressImageService } from 'src/app/_services/compress-image.service';
import { TranslateService } from '@ngx-translate/core';
import { DropdownHelperModel } from 'src/app/admin-panel/models/helpers/dropdown-helper.model';

@Component({
  selector: 'app-add-or-edit-tech-support',
  templateUrl: './add-or-edit-tech-support.component.html',
  styleUrls: ['./add-or-edit-tech-support.component.scss']
})
export class AddOrEditTechSupportComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public spinner: boolean = false
  public userId: string;
  public enableEdit: boolean = false;
  public pictureIsWrongFormat: boolean = false;
  public techSupportModel: TechSupportModel;
  public filePicture: any;
  public pictureFormat: Array<string>;
  public imagePath: string = './assets/images/icons/profile-picture-placeholder.png';
  public errorModel: { [k: string]: any } = {};
  public companyItems: Array<DropdownHelperModel> = new Array<DropdownHelperModel>();
  //#endregion
  //#region Constructor
  constructor(
    private openFile: ElementRef,
    private compressImage: CompressImageService,
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private administratorService: AdministratorService,
    public messageService: MessageService,
    public translate: TranslateService
  ) {
    if (this.config.data != undefined && this.config.data.id) {
      this.userId = this.config.data.id
      this.enableEdit=true;
      this.getTechSupportById(this.userId)
    }
    this.pictureFormat = ['image/png', 'image/jpg', 'image/jpeg'];
    this.techSupportModel = new TechSupportModel();
  }

  ngOnInit(): void {
    this.getallcompanynames();
  }
  //#endregion
  //#endregion
  //#region Public Methods
  getallcompanynames() {
    this.administratorService.getAllCompanyNames()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.companyItems = response;
        },
        error: errorResponse => {

        }
      });
  }
  addTechSupport(model: TechSupportModel) {
    this.errorModel = {}
    this.spinner = true;
    this.administratorService.addTechSupport(model, this.filePicture)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;
          this.ref.close(true)
        },
        error: errorResponse => {
          this.spinner = false;
          if (errorResponse.error.errors && errorResponse.error.errors.Email) {
            errorResponse.error.errors.Email.forEach((error: string) => {
              this.errorModel['Email'] = this.chooseErrorMessage(error);
            });
          }
          if (errorResponse.error.errors && errorResponse.error.errors.FirstName) {
            errorResponse.error.errors.FirstName.forEach((error: string) => {
              this.errorModel['FirstName'] = this.chooseErrorMessage(error);
            });
          }
          if (errorResponse.error.errors && errorResponse.error.errors.LastName) {
            errorResponse.error.errors.LastName.forEach((error: string) => {
              this.errorModel['LastName'] = this.chooseErrorMessage(error);
            });
          }
          if (errorResponse.error.errors && errorResponse.error.errors.Phone) {
            errorResponse.error.errors.Phone.forEach((error: string) => {
              this.errorModel['Phone'] = this.chooseErrorMessage(error);
            });
          }
          if (errorResponse.error.errors && errorResponse.error.errors.DateOfBirth) {
            errorResponse.error.errors.DateOfBirth.forEach((error: string) => {
              this.errorModel['DateOfBirth'] = this.chooseErrorMessage(error);
            });
          }
          else if (errorResponse.error) {
            this.messageService.add({ severity: 'error', summary: this.translate.instant('SYSTEM_PROFILES.VALIDATION_FAILED_MESSAGE'), life: 2000 });
          }
        }
      });
  }
  updateTechSupport(model: TechSupportModel) {
    this.errorModel = {}
    this.spinner = true;
    this.administratorService.updateTechSupport(model, this.filePicture)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;
          this.ref.close(true)
        },
        error: errorResponse => {
          this.spinner = false;
          if (errorResponse.error.errors && errorResponse.error.errors.Email) {
            errorResponse.error.errors.Email.forEach((error: string) => {
              this.errorModel['Email'] = this.chooseErrorMessage(error);
            });
          }
          if (errorResponse.error.errors && errorResponse.error.errors.FirstName) {
            errorResponse.error.errors.FirstName.forEach((error: string) => {
              this.errorModel['FirstName'] = this.chooseErrorMessage(error);
            });
          }
          if (errorResponse.error.errors && errorResponse.error.errors.LastName) {
            errorResponse.error.errors.LastName.forEach((error: string) => {
              this.errorModel['LastName'] = this.chooseErrorMessage(error);
            });
          }
          if (errorResponse.error.errors && errorResponse.error.errors.Phone) {
            errorResponse.error.errors.Phone.forEach((error: string) => {
              this.errorModel['Phone'] = this.chooseErrorMessage(error);
            });
          }
          if (errorResponse.error.errors && errorResponse.error.errors.DateOfBirth) {
            errorResponse.error.errors.DateOfBirth.forEach((error: string) => {
              this.errorModel['DateOfBirth'] = this.chooseErrorMessage(error);
            });
          }
          else if (errorResponse.error) {
            this.messageService.add({ severity: 'error', summary: this.translate.instant('SYSTEM_PROFILES.VALIDATION_FAILED_MESSAGE'), life: 2000 });
          }
        }
      });
  }
  cancel() {
    this.ref.close(false)
  }
  openAddImage() {
    var element = this.openFile.nativeElement.querySelector(".open-file");
    element.click();
  }
  onFileSelected(event: any) {
    this.pictureIsWrongFormat = false;
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      if (!this.pictureFormat.includes(event.target.files[0].type)) {
        this.pictureIsWrongFormat = true;
        return
      }
      let image: File = event.target.files[0]
      reader.readAsDataURL(image);// read file as data url
      this.compressImage.compress(image)
        .pipe(take(1))
        .subscribe(compressedImage => {
          this.filePicture = compressedImage;
        })
      reader.onload = (item) => { // called once readAsDataURL is completed
        if (item.target?.result) {
          this.techSupportModel.profilePictureUrl = item.target?.result as string
        }
      }
    }
  }

  getTechSupportById(id: string) {
    this.spinner = true;
    this.administratorService.getTechSupportById(id)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;
          this.techSupportModel.id = response.id;
          this.techSupportModel.firstName = response.firstName;
          this.techSupportModel.lastName = response.lastName;
          this.techSupportModel.roleName = response.roleName;
          this.techSupportModel.profilePictureUrl = response.profilePictureUrl;
          this.techSupportModel.email = response.email;
          this.techSupportModel.phone = response.phone;
          this.techSupportModel.dateOfBirth = new Date((response.dateOfBirth as string) + "Z");
          this.techSupportModel.assignedCompanies = response.assignedCompanyIds;
        },
        error: errorResponse => {
          this.spinner = false;
        }
      });
  }
  //#endregion
  //#Private Methods

  private chooseErrorMessage(error: string): string {
    return error.includes('required') || error.includes('null') || error.includes('\'\'') ?
      'SYSTEM_PROFILES.REQUIRED_FIELD' : error;  }

  //#endregion
}
